import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import timeentryAPIService from "./timeentryAPIService"

const initialState={
   entries:[],
   
   EntryisError:false,
   EntryisLoading:false,
   EntryisSuccess:false,
   
   UpdateEntryisError:false,
   UpdateEntryisLoading:false,
   UpdateEntryisSuccess:false,
   UpdateEntrymessage: '',
   
   CreateEntryisError:false,
   CreateEntryisLoading:false,
   CreateEntryisSuccess:false,
   CreateEntrymessage: '',
   
   Entrymessage: '',
};

//get all entries
export const getTimeEntries = createAsyncThunk(
    //action type string
    'entries/getAll',
    async(_,thunkAPI)=>{
        try {
            const entries = await timeentryAPIService.getTimeEntries();
            thunkAPI.dispatch(setEntries(entries));
            return entries;
        } catch (error) {
            const message =
                (error.response && 
                error.response.data && 
                error.response.data.message) ||
                error.message ||
                error.toString();

            return thunkAPI.rejectWithValue(message);  
        }
    }
);

export const getUserTimeEntries = createAsyncThunk(
  'entries/getUserTimeEntries',
  async(user,thunkAPI) => {
  try {
    const entries = await timeentryAPIService.getUserTimeEntries(user);
    thunkAPI.dispatch(setEntries(entries));
    return entries;
  } catch (error) {
    const message =
    (error.response && error.response.data && error.response.data.message) ||
    error.message ||
    error.toString();
    return thunkAPI.rejectWithValue(message);
  }
}
);

export const updateTimeEntry = createAsyncThunk(
  'entries/updateTimeEntry',
  async(args, thunkAPI) => {
    try {
      const entry = await timeentryAPIService.updateEntry(args.id, args.entryData, args.user);
      thunkAPI.dispatch(setEntries(entry));
      return entry;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createTimeEntry = createAsyncThunk(
  'entries/createTimeEntry',
  async(args, thunkAPI) => {
    try {
      const entry = await timeentryAPIService.createEntry(args.entryData, args.user);
      thunkAPI.dispatch(setEntries(entry));
      return entry;
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const timeentrySlice = createSlice({
    name: 'entries',
    initialState,
    reducers: {
      timeentryreset: (state) => initialState,
      setEntries: (state, action) => {
        state.entries = action.payload;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(getTimeEntries.pending, (state) => {
          state.EntryisLoading = true;
        })
        .addCase(getTimeEntries.fulfilled, (state, action) => {
          state.EntryisLoading = false;
          state.EntryisSuccess = true;
        })
        .addCase(getTimeEntries.rejected, (state, action) => {
          state.EntryisLoading = false;
          state.EntryisError = true;
          state.Entrymessage = action.payload;
        })
        .addCase(getUserTimeEntries.pending, (state) => {
          state.EntryisLoading = true;
        })
        .addCase(getUserTimeEntries.fulfilled, (state, action) => {
          state.EntryisLoading = false;
          state.EntryisSuccess = true;
        })
        .addCase(getUserTimeEntries.rejected, (state, action) => {
          state.EntryisLoading = false;
          state.EntryisError = true;
          state.Entrymessage = action.payload;
        })
        .addCase(updateTimeEntry.pending, (state) => {
          state.UpdateEntryisLoading = true;
        })
        .addCase(updateTimeEntry.fulfilled, (state, action) => {
          state.UpdateEntryisLoading = false;
          state.UpdateEntryisSuccess = true;
        })
        .addCase(updateTimeEntry.rejected, (state, action) => {
          state.UpdateEntryisLoading = false;
          state.UpdateEntryisError = true;
          state.UpdateEntrymessage = action.payload;
        })
        .addCase(createTimeEntry.pending, (state) => {
          state.CreateEntryisLoading = true;
        })
        .addCase(createTimeEntry.fulfilled, (state, action) => {
          state.CreateEntryisLoading = false;
          state.CreateEntryisSuccess = true;
        })
        .addCase(createTimeEntry.rejected, (state, action) => {
          state.CreateEntryisLoading = false;
          state.CreateEntryisError = true;
          state.CreateEntrymessage = action.payload;
        })
        ;
    },
  });
  
  export const { timeentryreset, setEntries } = timeentrySlice.actions;
  export default timeentrySlice.reducer;